import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { et3ReadableDecimalNumber } from "../../helpers/et3-data-helper";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import i18n from "../../constants/i18n";
import getDashBoardStore from "../../stores/dashboard-store";
import SideBarStat from "./SideBarStat";

const AdminSalary = withLiteObserverAndTheme(() => {
  const isKhattabaAdmin = getCorePersonalStore().isManualKhattabaAdmin.get();
  const adminSalary = getDashBoardStore().khattabatAdminRemuneration.get();
  const roundedSalary = `${et3ReadableDecimalNumber(adminSalary, 2)}`;

  return !isKhattabaAdmin ? null : (
    <SideBarStat
      label={i18n.get("KHATTABAT_REMUNERATION")}
      value={`${roundedSalary} $`}
    />
  );
});
export default AdminSalary;
